import type { Exhibition, Award } from "@/types";

export const exhibitions: Exhibition[] = [
  {
    year: "2024",
    title: "Urban Narratives",
    venue: "Gallery Modern, Los Angeles",
  },
  {
    year: "2023",
    title: "Light & Shadow",
    venue: "Photography Center, New York",
  },
  {
    year: "2023",
    title: "Portraits of Tomorrow",
    venue: "Art Space Contemporary, San Francisco",
  },
  {
    year: "2022",
    title: "Landscapes Reimagined",
    venue: "Nature Gallery, Denver",
  },
];

export const awards: Award[] = [
  {
    year: "2024",
    title: "International Photography Award - Portrait Category",
  },
  { year: "2023", title: "Sony World Photography Awards - Finalist" },
  { year: "2022", title: "National Geographic Photo Contest - Winner" },
  {
    year: "2021",
    title: "Professional Photographers of America - Excellence Award",
  },
];

export const clients: string[] = [
  "Vogue Magazine",
  "National Geographic",
  "Adobe Creative",
  "Tesla Motors",
  "Airbnb",
  "Netflix",
  "The New York Times",
  "Condé Nast Traveler",
];
